import { createAsyncThunk } from "@reduxjs/toolkit";
import { displayAlert } from "../slice/alertSlice.tsx";
import { AxiosError, isAxiosError } from "axios";
import helpApi from "../api/helpApi.tsx";
import { handleThunkError } from "./handleThunkError";

interface ApiErrorList {
  [key: string]: string[];
}

export const fetchSubjects = createAsyncThunk(
  "help/fetchSubjects",
  async (_, thunkAPI) => {
    try {
      const response = await helpApi.fetchSubjects();
      return response.data;
    } catch (e: unknown) {
      handleThunkError(e, thunkAPI.dispatch, "Failed to fetch profile data.");
      return thunkAPI.rejectWithValue("Failed to fetch profile data.");
    }
  },
);

export const setContactUs = createAsyncThunk(
  "help/setContactUs",
  async (data: FormData, thunkAPI) => {
    try {
      const response = await helpApi.setContactUs(data);
      return response.data.data;
    } catch (e: unknown) {
      if (isAxiosError(e) && e.response?.status === 429)
        return thunkAPI.rejectWithValue("Rate limited.");
      // Your existing error alert logic
      if (e instanceof AxiosError && e.response && e.response.data) {
        const data = e.response.data as ApiErrorList;
        Object.keys(data).forEach((key: string) =>
          thunkAPI.dispatch(
            displayAlert({
              type: "error",
              text: `${key} ${data[key].join(". ")}`,
            }),
          ),
        );
      }
      return thunkAPI.rejectWithValue("Failed to send message.");
    }
  },
);
